import React, { useEffect, useState } from "react";
import { styled } from "styled-components";
import { Color } from "../../theme/Color";
import { Font } from "../../theme/Font";
import FooterLogo from "../../assets/footer/footer_logo.webp";
import AICPASOC from "../../assets/footer/aicpa-soc.webp";
import GDPR from "../../assets/footer/gdpr.webp";
import { Link } from "react-router-dom";
import AppStoreLogo from "../../assets/footer/appstore_logo.webp";
import GooglePlay from "../../assets/footer/googleplay_logo.webp";
import { FaLinkedinIn, FaFacebookF, FaTwitter, FaEnvelope, FaPhoneAlt } from "react-icons/fa";
import { useHistory } from "react-router-dom";
import { isValidEmail } from "../../utils/validation";
import { SubmitButton } from "../DesignComponent/DesignComponents";
import axios from "axios";
import { API_URL } from "../../redux/constants/constants";

const Section80 = styled.section`
  padding-top: 80px;
  padding-bottom: 80px;
  background-color: #090a43;
  @media (max-width: 767px) {
    padding-top: 40px;
    padding-bottom: 40px;
  }
`;
const ListItem = styled.li`
  font-family: ${Font.basel};
  list-style: none;
  margin-bottom: 16px;
  font-size: 14px;
  font-weight: 500;
`;

const Footer2 = () => {
  const [Email, setEmail] = useState("");
  const [emailError, setEmailError] = useState(false);
  const navigate = useHistory();
  const [pageUrl, setPageUrl] = useState(window.location.href);
  const [visitedPages, setVisitedPages] = useState([]);

  useEffect(() => {
    setPageUrl(window.location.href);
    const storedPages = JSON.parse(sessionStorage.getItem("visitedPages")) || [];
    setVisitedPages(storedPages);
  }, [window.location.href]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!isValidEmail(Email)) {
      setEmailError(true);
      return;
    } else {
      const data = [
        {
          Last_Name: "null",
          Email: Email,
          Page_Link: pageUrl,
          User_Visited_Links: visitedPages.join(", "),
          Lead_URL: visitedPages[0],
        },
      ];

      try {
        await axios.post(`${API_URL}custom/v1/lead`, data, {
          headers: {
            "Content-Type": "application/json",
          },
        });
        navigate.push({ pathname: "/schedule-demo", state: Email });
      } catch (error) {
        console.error("Error:", error);
      }
    }
  };

  const handleInput = (event) => {
    setEmail(event.target.value);
  };

  return (
    <Section80 className="Footer text-white position-relative">
      <div className="container">
        <div className="row gap-md-0">
          <div className="col-12 col-md-5 mb-5 mb-md-0">
            <div className="row">
              <div className="col-12">
                <p className="fs-18" style={{ fontFamily: Font.basel, lineHeight: "1.2" }}>
                  Schedule a free demo to see LeanSuite in action
                </p>
                {/* <h2 style={{ color: '#8394F6' }}>
                  All in one place
                </h2> */}
              </div>
              <div className="col-12  text-white p-3 rounded-3">
                <form
                  className=" mx-lg-0 mx-auto"
                  onSubmit={handleSubmit}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      backgroundColor: "rgba(255, 255, 255, 0.1)",
                      border: "1px solid rgba(255, 255, 255, 0.3)",
                      borderRadius: "8px",
                      padding: "8px",
                      maxWidth: "500px",
                    }}
                  >
                    {/* Input Container with Icon */}
                    <div style={{ position: "relative", flex: 1 }}>
                      <input
                        type="email"
                        placeholder="Enter your work email"
                        value={Email}
                        name="email"
                        onChange={handleInput}
                        style={{
                          backgroundColor: "transparent",
                          border: "none",
                          color: "#fff",
                          width: "100%",
                          padding: "12px 12px 12px 12px",
                          fontFamily: "sans-serif",
                          fontSize: "14px",
                          outline: "none",
                        }}
                      />
                      
                    </div>

                    {/* Submit Button */}
                    <button
                      onClick={handleSubmit}
                      style={{
                        backgroundColor: "#FFBF00", // Bright yellow
                        border: "none",
                        color: "#000",
                        padding: "12px 20px",
                        fontWeight: "600",
                        borderRadius: "6px",
                        cursor: "pointer",
                        marginLeft: "8px",
                      }}
                    >
                      Schedule Demo
                    </button>
                  </div>

                  <p className="fs-10 mb-0 mt-1" style={{ color: Color.lightwhite }}>
                    By clicking "Schedule Demo" you agree to LeanSuite's{" "}
                    <a
                      href="/legal/privacy"
                      className="text-white text-decoration-none fw-medium"
                    >
                      Privacy Policy
                    </a>
                  </p>
                </form>
              </div>

              <div className="col-12">
                <Link to="/">
                  <img
                    src={FooterLogo}
                    className="w-100 mb-4"
                    style={{ maxWidth: "150px" }}
                    loading="lazy"
                    alt="TheLeansuite Logo"
                  />
                </Link>
              </div>

              <div className="col-12">
                <div className="d-flex flex-wrap gap-2 justify-content-md-start justify-content-center">
                  {[
                    {
                      href: "https://www.linkedin.com/company/theleansuite",
                      icon: <FaLinkedinIn />,
                      label: "Visit LinkedIn",
                    },
                    {
                      href: "https://www.facebook.com/theleansuite",
                      icon: <FaFacebookF />,
                      label: "Visit Facebook",
                    },
                    {
                      href: "https://twitter.com/theleansuite",
                      icon: <FaTwitter />,
                      label: "Visit Twitter",
                    },
                    {
                      href: "mailto:info@theleansuite.com",
                      icon: <FaEnvelope />,
                      label: "Send Email",
                    },
                    {
                      href: "tel:+1234567890",
                      icon: <FaPhoneAlt />,
                      label: "Call Us",
                    },
                  ].map((item, index) => (
                    <a
                      key={index}
                      href={item.href}
                      className="d-flex justify-content-center align-items-center"
                      style={{
                        width: "40px",
                        height: "40px",
                        backgroundColor: "rgba(255, 255, 255, 0.05)",
                        borderRadius: "4px",
                        color: "#fff",
                        textDecoration: "none",
                      }}
                      target="_blank"
                      aria-label={item.label}
                    >
                      {React.cloneElement(item.icon, { size: 16 })}
                    </a>
                  ))}
                </div>
              </div>

            </div>
          </div>

          <div className="col-12 col-md-7">
            <div className="row text-white justify-content-around">
              <div className="col-sm-6 col-lg-3 mb-4">
                <h6 className="fw-bold mb-3">SOLUTIONS</h6>
                <ul className="list-unstyled">
                  {[
                    ["/what-is-leansuite", "LeanSuite 360"],
                    ["/suggestion-platform-for-hr", "Idea"],
                    ["/issue-tracker-for-safety", "Failure Tag"],
                    ["/continuous-improvement-for-operations", "Kaizen"],
                    ["/competency-management", "Competencies"],
                    ["/learning-management-system", "Training"],
                    ["/loss-and-cost-management", "Loss and Cost Management"],
                    ["/qa-matrix", "QA Matrix"],
                    ["/cilr-management", "CILR"],
                    ["/gemba-walker", "Gemba Walker"],
                    ["/rca", "Root Cause Analysis"],
                    ["/job-cover-matrix", "Job Cover Matrix"],
                    ["/lean-creator", "Lean Creator"],
                    ["/kpi-builder", "KPI Builder"]
                  ].map(([href, label]) => (
                    <ListItem key={href}><Link to={href} className="text-white text-decoration-none">{label}</Link></ListItem>
                  ))}
                </ul>
              </div>
              <div className="col-sm-6 col-lg-3 mb-4">
                <h6 className="fw-bold mb-3">RESOURCES</h6>
                <ul className="list-unstyled">
                  {["ebooks", "templates", "videos", "webinars", "blogs"].map((slug) => (
                    <ListItem key={slug}><Link to={`/${slug}`} className="text-white text-decoration-none">{slug.charAt(0).toUpperCase() + slug.slice(1)}</Link></ListItem>
                  ))}
                </ul>
              </div>
              <div className="col-sm-6 col-lg-3 mb-4">
                <h6 className="fw-bold mb-2">COMPANY</h6>
                <ul className="list-unstyled">
                  {[
                    ["/aboutus", "About Us"],
                    ["/theleansuite-partner-community", "Partner Network"],
                    ["/press", "Press"],
                    ["/contact", "Contact Us"],
                    ["/blogs", "Blogs"]
                  ].map(([href, label]) => (
                    <ListItem key={href}><Link to={href} className="text-white text-decoration-none">{label}</Link></ListItem>
                  ))}
                </ul>
              </div>
              <div className="col-sm-6 col-lg-3 mb-4">
                <h6 className="fw-bold mb-3">LEGAL</h6>
                <ul className="list-unstyled">
                  {[["/legal/terms", "Terms of Service"], ["/legal/privacy", "Privacy Policy"]].map(([href, label]) => (
                    <ListItem key={href}><Link to={href} className="text-white text-decoration-none">{label}</Link></ListItem>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>

        <hr className="my-4" />

        <div className="row align-items-center py-4 d-flex justify-content-between">
          <div className="col-12 col-md-4 mb-3 mb-md-0 d-flex justify-content-center justify-content-md-start gap-4 align-items-center">
            <img src="https://staging2.theleansuite.com/wp-content/uploads/2025/06/Logo_x2F_Colour_x2F_Full.png" alt="AICPASOC" loading="lazy" style={{ height: "100%" }} />
            {/* <img src={AICPASOC} alt="AICPASOC" loading="lazy" style={{ maxWidth: "90px" }} /> */}
            <img src="https://staging2.theleansuite.com/wp-content/uploads/2025/06/eu-gdpr-security-1741-1.png" alt="GDPR" loading="lazy" style={{ maxWidth: "60px" }} />
            {/* <img src={GDPR} alt="GDPR" loading="lazy" style={{ maxWidth: "60px" }} /> */}
          </div>

          <div className="col-12 col-md-5 text-center text-md-end">
            <span style={{ color: "#fff", fontFamily: Font.basel, fontSize: "14px", marginRight: "10px" }}>
              Download the LeanSuite App:
            </span>
            <a href="https://apps.apple.com/us/app/theleansuite/id1660500404" target="_blank" rel="noopener noreferrer" className="me-2">
              <img src={AppStoreLogo} alt="App Store" loading="lazy" style={{ maxWidth: "120px" }} />
            </a>
            <a href="https://play.google.com/store/apps/details?id=com.leansuite" target="_blank" rel="noopener noreferrer">
              <img src={GooglePlay} alt="Google Play" loading="lazy" style={{ maxWidth: "120px" }} />
            </a>
          </div>
        </div>
      </div>
    </Section80>
  );
};

export default Footer2;
